<div *ngIf="mode === 'icon'" class="date-picker-container">
  <!-- The input field bound to selectedDate -->
  <input
    [ngModel]="selectedDate"
    [matDatepicker]="datepicker"
    (ngModelChange)="onDateChange($event)"
    [matDatepickerFilter]="dateFilter"
    [ngStyle]="{
      width: '0px',
      padding: 0,
      margin: 0,
      border: 0,
      height: '30px'
    }"
    [max]="max"
    [min]="min"
  />

  <!-- Button to trigger the calendar popup -->
  <ws-button (click)="openDatepicker(datepicker)" [tooltip]="tooltip">
    <mat-icon>calendar_today</mat-icon>
  </ws-button>

  <!-- Mat Datepicker component -->
  <mat-datepicker
    #datepicker
    [yPosition]="'below'"
    [dateClass]="getClassByDate"
  >
  </mat-datepicker>
</div>

<div *ngIf="mode === 'field'" class="date-picker-container field">
  <input
    (ngModelChange)="onDateChange($event)"
    [matDatepicker]="datepicker"
    [ngModel]="selectedDate"
    [placeholder]="placeholder"
    [matDatepickerFilter]="dateFilter"
    [max]="max"
    [min]="min"
    matInput
  />
  <mat-datepicker-toggle [for]="datepicker" matSuffix>
    <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker
    #datepicker
    [yPosition]="'below'"
    [dateClass]="getClassByDate"
  >
  </mat-datepicker>
</div>
